<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="select_container" style="float:left; width:100%">
    <select class="form-control" v-bind:id="'select_' +  getId()" data-fouc v-select='selected' v-on:change="onChange">
      <option value="" style="">{{$store.translate('select_team')}}</option>
      <option v-for="option in teams" v-bind:value="option.Id">
        {{ option.Name }}
      </option>
    </select>
  </div>
</template>

<script>


  let message = ""; 
  var teams = []; 
  var selected = "";
  var placeholder = "";
  export default {
    name: "team-select-selector",
    props: {      
      value: {
        type: String,
        default: null
      },
      loadDataOnInit: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        placeholder,
        message: "",       
        teams,
        selected
      };
    },
    methods: {
      fetchReloadData(val) {
        this.loadTeams(val);
      },
      selectTeam(selected) {        
        $("#select_" + this.getId()).val(selected);
        $("#select_" + this.getId()).trigger('change');
      },
      onChange() {        
        this.$emit('event-change-team', $("#" + 'select_' + this.getId() + " option:selected").val());
        this.$root.$emit('teamChange', $("#" + 'select_' + this.getId() + " option:selected").val());
      },      
      getId() {
        return this._uid;
      },               
      async loadTeams(selected) {
        try {
          this.teams = [];
          this.$http.get('/api/Teams/v1?').then(async response => {

            this.teams = response.data;

            if (this.teams !== null && this.teams.length > 0) {
              this.teams = this.teams.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            $('#' + 'select_' + this.getId()).select2();

          }).then((async response => {
            if (selected != null) {
              $("#select_" + this.getId()).val(selected);
              $("#select_" + this.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      }   
    },    
    watch: {

    },
    mounted() {
      if (this.loadDataOnInit == true) {
        this.loadTeams(this.value);
      }
      this.placeholder = this.$store.translate('select_team');
      
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/team/team-select-selector.vue